import { ID, TaskListItemTypes, TaskListTreeItem } from '@griply/types';
import { getNotAllowedParentGoalIds } from '@griply/utils';
import { useCallback } from 'react';
import { useEntityLinks } from 'shared/hooks/use-entity-links';

import { useGoals } from './use-goals';

// Reads every goal, not the list's own: a descendant the list filtered out still closes a cycle.
export const useCanDropGoalsOnItem = () => {
  const goals = useGoals();
  const links = useEntityLinks();

  return useCallback(
    (
      target: { id: ID },
      draggedItems: Pick<TaskListTreeItem, 'id' | 'type'>[],
    ) =>
      draggedItems.every(
        (dragged) =>
          dragged.type !== TaskListItemTypes.Goal ||
          !getNotAllowedParentGoalIds(dragged.id, { goals, links }).has(
            target.id,
          ),
      ),
    [goals, links],
  );
};
